import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cotarTextos'
})
export class CotarTextosPipe implements PipeTransform {

  transform(value: any, caracter:any): any {
    console.log("Corte texto -->", value, caracter)
    if(value == '' || value == null || caracter == null) return value
    return value.split(caracter)[0];
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/cotar-textos.pipe.ts